import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const LandingRedirectMeli = () => {
    return (
        <div className="meli-landing-page">
            <Container className="h-100">
                <Row className="justify-content-center align-items-center h-100">
                    <Col className="text-center">
                        <h1 className="display-1 fw-bold text-primary mb-0">
                            MercadoLibre
                        </h1>
                        <h2 className="display-3 fw-bold text-secondary">
                            ALANI360
                        </h2>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LandingRedirectMeli;
